import React from 'react'

const SvgCalendarTimesFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 13.79l-.914.913-1.21-1.21a3.1 3.1 0 00-4.383 4.383l1.21 1.21-1.21 1.21c-.48.48-.767 1.08-.866 1.704H6c-1.333 0-2-.667-2-2V10h16v3.79zM9.002 17c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998zm0-4c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998z'
    />
    <path d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v2H4V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.603 19.086l-2.71-2.71a1.048 1.048 0 011.482-1.483l2.71 2.71 2.711-2.71a1.048 1.048 0 011.483 1.482l-2.71 2.71 2.71 2.711a1.048 1.048 0 11-1.483 1.483l-2.71-2.71-2.71 2.71a1.048 1.048 0 01-1.483-1.483l2.71-2.71z'
    />
  </svg>
)

export default SvgCalendarTimesFilled
